import { DASHBOARD_URL } from 'constants/app';
import { useSession } from 'hooks/useSession';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router';
import { fetchWrapper } from 'utils/apiFetch';

function PancardUserDashboard() {
    const [data, setData] = useState(null); // to store API data
    const [loading, setLoading] = useState(true); // to manage loader
    const [error, setError] = useState(null);
    const {userid} = useSession();
    // const [rechargeLoading,setrechargeLoading] = useState(false);
    const [currentTime, setCurrentTime] = useState(new Date());
    const navigate = useNavigate()
    useEffect(()=> {
        (() => {
            const role = localStorage.getItem('role');
            if(role.toLowerCase() != 'Pancard Agent'){
                navigate(DASHBOARD_URL[role])

            }
        })()
    },[])

    useEffect(() => {
        
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetchWrapper(
                    `https://pro.mokshiq.in/get_user_profile?user=${userid}`
                );
               
                setData(response.data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false); // hide loader
            }
        };
        fetchData();
        const timer = setInterval(() => {
            setCurrentTime(new Date());
          }, 1000);
        
          return () => clearInterval(timer); 

       
    }, []);
    return (
        <main>
            <div class="container-fluid mt-3">
            {loading ==true ?(
                <div 
                  className="page-loader-overlay d-flex justify-content-center align-items-center"
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(255,255,255,0.7)',
                    zIndex: 3000,
                  }}
                >
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ):
                <div class="row">
                    <div class="col-sm-6 col-md-3">
                        <div class="card project-total-card">
                            <div class="card-body">
                                <div class="d-flex position-relative">
                                    <h5 class="text-dark txt-ellipsis-1">Wallet Balance</h5>
                                    <div class="clock-box">
                                        <div class="clock">
                                            <div class="hour" id="hour"></div>
                                            <div class="min" id="min"></div>
                                            <div class="sec" id="sec"></div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="d-flex">
                                        <h2 class="text-info-dark hour-display">₹ {data?.wallet_balance?.toFixed(2)}
                                        </h2>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-3">
                        <div class="card project-total-card">
                            <div class="card-body">
                                <div class="d-flex position-relative">
                                    <h5 class="text-dark txt-ellipsis-1">Credit Wallet</h5>
                                    <div class="clock-box">
                                        <div class="clock">
                                            <div class="hour" id="hour"></div>
                                            <div class="min" id="min"></div>
                                            <div class="sec" id="sec"></div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="d-flex">
                                        <h2 class="text-info-dark hour-display">₹ {data?.nwallet_balance?.toFixed(2) ?? "0.0"}
                                        </h2>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-3">
                        <div class="card bg-success-300 project-details-card">
                            <div class="card-body">
                                <div class="d-flex gap-2">
                                    {/* <span class="badge bg-white-300 text-success-dark p-1 b-r-10">⚡ {data.id} </span> */}
                                    <span class="badge bg-transparent dashed-1-dark-light text-success-dark ms-2 p-1 b-r-10">{data.kyc}</span>
                                </div>
                                <div class="mt-4">
                                    <h5 class="f-w-600 text-success-dark txt-ellipsis-1">{data.name}</h5>
                                    <p class="text-success f-s-13 txt-ellipsis-1 mb-0">+91 {data.mobile}</p>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-3">
                        <div class="card project-total-card">
                            <div class="card-body">
                                <div class="d-flex position-relative">
                                    <h5 class="text-dark txt-ellipsis-1">Current Time</h5>
                                    <div class="clock-box">
                                        <div class="clock">
                                            <div class="hour" id="hour"></div>
                                            <div class="min" id="min"></div>
                                            <div class="sec" id="sec"></div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="d-flex">
                                        <h3 class="text-info-dark hour-display">{currentTime.toLocaleTimeString()}
                                        </h3>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card orders-provided-card">
                            <div class="card-body">
                                <i class="ph-bold  ph-circle circle-bg-img"></i>
                                <div>
                                    <p class="f-s-18 f-w-600 text-dark txt-ellipsis-1">📈 Today's Earning</p>
                                    <h2 class="text-secondary-dark mb-0">{data.daily_sales.other_products.total_profit}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card orders-provided-card">
                            <div class="card-body">
                                <i class="ph-bold  ph-circle circle-bg-img"></i>
                                <div>
                                    <p class="f-s-18 f-w-600 text-dark txt-ellipsis-1">📈 Today's Sales</p>
                                    <h2 class="text-secondary-dark mb-0">{data.daily_sales.other_products.total_amount}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card product-store-card">
                            <div class="card-body">
                                <i class="ph-bold  ph-circle circle-bg-img"></i>
                                <div>
                                    <p class="text-success f-s-18 f-w-600 txt-ellipsis-1">📝 Monthly Sales
                                    </p>
                                    <h2 class="text-success-dark mb-0">{data.monthly_sales.other_products.total_amount}</h2>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card product-store-card">
                            <div class="card-body">
                                <i class="ph-bold  ph-circle circle-bg-img"></i>
                                <div>
                                    <p class="text-success f-s-18 f-w-600 txt-ellipsis-1">📝 Monthly
                                        Earning</p>
                                    <h2 class="text-success-dark mb-0">{data.monthly_sales.wallet_settlement.total_charge}</h2>
                                </div>

                            </div>
                        </div>
                    </div>
                    




                </div>
                }
            </div>


        </main>
    )
}

export default PancardUserDashboard